$(window).resize(function() {
  //equalheight(".product-item");
}); 

$(window).unload(function () {
    // Remove the cookie
    $.cookie("CURRENCYACTIVE", null);
});

$(".form-close, .search-icon").on('click', function(){
  $(".mobile-search-overlay").toggleClass("open");
});

$('body').on('click', '.product-variant-d', function () {
  var id = $(this).find("input").attr("value");
  $(this).parents(".designmatch-item").find(".designmatch-image-border img").each(function(){
    if($(this).attr("data-image-id") == id){
      $(this).parents(".designmatch-item").find(".designmatch-image-border img").css("display", "none");
      $(this).css("display", "block");
    }                           
  });
});

$(document).ready(function () {

  if ($("#front-hero").length){
    if (cookieExists("frontHero")) {
      document.getElementById("front-hero").style.display = "none";
    } else {
      createCookie("frontHero", "", 0.05);
    }
  }

  

  

  $(".product-variants input[name='id']").val($(".product-variants .dropdown .dropdown-list a:first").attr("data-value"));

  $(document).on("click", ".product-variants .dropdown .dropdown-list a", function(e){
    e.preventDefault();
    $(".product-variants input[name='id']").val($(this).attr("data-value"));
    var variantPrice = $(this).attr("data-price");
    var comparePrice = $(this).attr("data-compare-price");
    $(this).closest("form").find(".current-price").html(variantPrice);
    $(this).closest("form").find(".sale-price").html(comparePrice);
    $(".btn.purchase").removeClass("product-added").html("Add to basket");
  });

  // $('input[type="text"][name="id"]').each(function () {
  //   var $this = $(this);
  //   $this.change(function () {
  //     var parent = $this.parent('.product-variant');
  //     var variantPrice = $('.variant-price', parent).html();
  //     $(".current-price").html(variantPrice);
  //     return true;
  //   });
  // });
  
  if($("body").hasClass("page-slider-test")){
  	$("body").addClass("template-index");
  }
  
  var price = "";
  $(".price-fix .item_line_price").each(function(){
    var id = $(this).attr("id");
    var price = $(this).html();
    $(".price_fix_cart").each(function(){
      if($(this).parents(".product-in-cart").find(".product-info .rvid").text() == id){
        $(this).html(price);
      }
    })
  });
  
  $(".replace-price").html($(".total-price").html());

  $(".qtyplus, .qtyminus, .remove").on('click', function(){
    setTimeout(function(){
      window.location.reload();
    },500);
  })

  $(".hero .scroll").click(function(){
    var headerOffset = $("#main").offset().top + 1;
    $("html, body").stop().animate({ scrollTop: headerOffset }, 1000, 'swing', function () {
      
    });
  });

  $(".menuclose").on('click', function(){
    if($('body').hasClass("menu-open")){
      $('body').removeClass("menu-open");
    } 
  })
  
  $(".currencies span[data-currency='" + window.Shopify.currency.active + "']").addClass("active");
  $(document).on('click', ".currencies span", function (e) {
    window.location.href = window.location.href.split('?')[0] + "?currency=" + $(this).data('currency');
  })

  $(".product-variant").on('click', function(){
  	var id = $(this).find("input").attr("value");
    $(".product-image img").each(function(){
      if($(this).attr("data-image-id") == id){
        $(".product-image img").css("display", "none");
      	$(this).css("display", "block");
      }                           
    })
  })

  // var winHeight = $(window).height() + 1;
  // var $root = $('html, body');
  // $('.front-arrow img').click(function () {
  //   $root.animate({
  //     scrollTop: winHeight
  //   }, 500);

  //   return false;
  // });


  
  Shopify.onItemAdded = function(cart) {
    setTimeout(function(){
      addToCart();
    }, 500);
  };
  
  $(document).on("click", ".designmatch-form .purchase", function(){
    if($(this).closest(".cart-form.custom").find(".product-variant-d input:checked").length == 0){
      console.log("none selected");
    }else{
      addToCart();
    }
  });


  $(document).on("submit", "form[action='/cart/add']", function () {
    $(this).find(".btn.purchase").addClass("product-added").html("Added <i></i>");
  });
  
  cartCountItems();
  function addToCart(){
    cartCountItems();
    // $(".product-added-to-cart").addClass("active");
    // setTimeout(function () {
    //   $(".product-added-to-cart").removeClass("active");
    // }, 4000);
  }

  $('.thickness .size-wrapper a:first').addClass('selected');


  $(".product-cart-title").each(function(){

    if($(this).text() == "Canvas"){
      $(this).parents(".product-in-cart").find(".cart-quantity p").text("Quantity: 1");
      $(this).parents(".product-in-cart").find(".cart-quantity input, .qty-wrap").hide();
    }

    if($(this).text() !== "Canvas"){
      $(this).parents(".product-in-cart").find(".product-info span").hide();
    }
  });

  $(".collection-filters .dropdown.tags").find(".dropdown-list a[href='" + window.location.pathname + "']").addClass("selected");
  var dropdownText = $(".collection-filters .dropdown.tags").find(".dropdown-list a[href='" + window.location.pathname + "']").text();
  if(dropdownText != "All"){
    $(".collection-filters .dropdown.tags").find(".dropdown-btn").text(dropdownText);
  }

  var array = [];  
  $(".canvasQty").each(function(){
    array.push($(this).text());
  });

  var canvasqty = 0;
  for (var i = 0; i < array.length; i++) {
    canvasqty += array[i] << 0;
  }

  var totalInCart = $("#totalQty").text();
  var arrLength = array.length;
  var total = totalInCart - canvasqty + arrLength;

  $(".cart-count-num").each(function(){
    $(this).text(total);
  })


  // $(".aspect-box").on('click', function(e){
  //   $(".btm_price").text("");
  //   $(".product-image .product-image img" ).attr("src", "//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_grande.gif");
  //   $(".product-image .product-image p.titel" ).text("");
  //   $(".line-item-property__field.text input" ).val("");
  //   $(".line-item-property__field.img input" ).val("");
  //   $(".canvas-step-overlay").remove();
  //   var aspectRatioDown = 0.7;
  //   var aspectRatioUp = 1.43;

  //   var heightInput = $(".measurement_div #0 input");
  //   heightInput.removeAttr("disabled");
  //   heightInput.attr({min:"30", max:"300"});
  //   heightInput.val("");

  //   var widthInput = $(".measurement_div #1 input");
  //   widthInput.removeAttr("disabled");
  //   widthInput.attr({min:"30", max:"300"});
  //   widthInput.val("");
    

  //   if($(this).hasClass("horizontal-box")){
  //     $(".horizontal-prod, .vertical-prod, .square-prod").hide();
  //     $(".horizontal-prod").show();
  //     widthInput.keyup(function(e){
  //       //console.log(e.keyCode);
  //       heightInput.val(Math.ceil(parseInt(widthInput.val()) * aspectRatioDown));
  //     });
  //     heightInput.keyup(function(e){
  //       widthInput.val(Math.ceil(parseInt(heightInput.val()) * aspectRatioUp));
  //     });



  //   }else if($(this).hasClass("square-box")){
  //     $(".horizontal-prod, .vertical-prod, .square-prod").hide();
  //           $(".square-prod").show();

  //     widthInput.keyup(function(e){
  //       heightInput.val(Math.ceil(widthInput.val()));
  //     });
  //     heightInput.keyup(function(e){
  //       widthInput.val(Math.ceil(heightInput.val()));
  //     });



  //   }else if($(this).hasClass("vertical-box")){
  //     $(".horizontal-prod, .vertical-prod, .square-prod").hide();
  //     $(".vertical-prod").show();
  //     widthInput.keyup(function(e){
  //       heightInput.val(Math.ceil(widthInput.val() * aspectRatioUp));
  //     });
  //     heightInput.keyup(function(e){
  //       widthInput.val(Math.ceil(heightInput.val() * aspectRatioDown));
  //     });
  //   }
  // });


  $(".sort-button").each(function() {
    $(this).click(function (e) {
      e.preventDefault();

      var parent = $(this).parent('.sorting-wrapper');

      $(".sort-options", parent).toggleClass('active');
      //console.log(parent);
      return false;
    });
  });

  

  
  
  
  //
  //$(".dropdown button").on('click', function(e){
  //
  //  e.preventDefault(); 
  //   var text = $(this).text();
  //  $(".category-wrapper .dropdown-btn").html(text + '<img src="//www.thegallery.nu/cdn/shop/t/35/assets/arrow-down.png?v=113949660642048992271735325928">');
  //                                            $(".dropdown").removeClass("open");
  //});
  //
  //$(".dropdown a").on('click', function(e){
  //
  //   e.preventDefault(); 
  //  var text = $(this).text();
  //  $(".sorting-wrapper .dropdown-btn").html(text + '<img src="//www.thegallery.nu/cdn/shop/t/35/assets/arrow-down.png?v=113949660642048992271735325928">');
  //                                           $(".dropdown").removeClass("open");
  //});


  


  //menu bar scroll function + slide
    

  function colorCheck(){
    if($(".flickity-slideshow .slide.is-selected").hasClass("dark")){
      $("body").addClass("slidertheme-light");
      $("body").removeClass("slidertheme-dark");
    }else{
      $("body").removeClass("slidertheme-light");
      $("body").addClass("slidertheme-dark");
    }
  }


  var $nav = $('.main-header');
  var $window = $(window);
  var winHeight = $window.height();   
  var winWidth = $window.width();   


  // $(".flickity-slideshow").flickity({
  //   cellSelector: '.slide',
  //   lazyLoad: true,
  //   pageDots: true,
  //   prevNextButtons: false,
  //   wrapAround: true,
  //   autoPlay: 8000,
  //   groupCells: 1,
  //   contain: true,
  //   on: {
  //     change: function( index ) {
  //       colorCheck();
  //     }
  //   }
  // });
  colorCheck();

  if($("body").hasClass("template-index")){
    $window.on("scroll", function () {
      if ($(this).scrollTop() > $("#front-hero").outerHeight() ) {
        $("html").addClass("header-fixed");
      } else {
        $("html").removeClass("header-fixed");
      }
    }).on("resize", function(){ // If the user resizes the window
      winHeight = $(this).height(); // you'll need the new height value
    });

    

  }else{
    

  }

  // Header
  // $('body').toggleClass("menu-open");
  
  $(".menu-trigger").on('click', function(){
    $('body').toggleClass("menu-open");
  
    // if ($("#front-hero").length) {
    //   if ($(window).width() < 768 && window.scrollY < $("#front-hero").height()) {
    //     var headerOffset = $("#main").offset().top;
    //     $("html, body").stop().animate({ scrollTop: headerOffset }, 200, 'swing', function () {

    //     });
    //   }
    // }
    
  });

  $(".menu-trigger-search").on('click', function (e) {
    e.preventDefault();
    if($("body").hasClass("menu-open")){
      $('#header .form-search input.search-box').focus();
    }else{
      $('body').addClass("menu-open");
      setTimeout(function () {
        $('#header .form-search input.search-box').focus();
      }, 500)

      // if ($("#front-hero").length) {
      //   if ($(window).width() < 768 && window.scrollY < $("#front-hero").height()) {
      //     var headerOffset = $("#main").offset().top;
      //     $("html, body").stop().animate({ scrollTop: headerOffset }, 200, 'swing', function () {

      //     });
      //   }
      // }

    }
  });




  // Product Page
  $("#productImages").owlCarousel({
    items: 1,
    singleItem: true
  });



  $("#mobile-menu-trigger").click(function() {
    $("nav#menu").fadeToggle();
    if (menu_open) {
      menu_open = false;
      $("#menucon").animate({height: 0},600) 
    } else {
      menu_open = true;
      if ($('body').hasClass('template-index')) {
        $("#menucon").animate({height: $("nav#menu").height()+75},600)
      } else {
        $("#menucon").animate({height: $("nav#menu").height()+40},600)
      }
    }
  });


  $('.qtyplus').click(function(e){
    e.preventDefault();
    fieldName = $(this).attr('field');
    var currentVal = parseInt($('input[id='+fieldName+']').val());
    if (!isNaN(currentVal)) {
      $('input[id='+fieldName+']').val(currentVal + 1);
    } else {
      $('input[id='+fieldName+']').val(0);
    }
  });
  $(".qtyminus").click(function(e) {
    e.preventDefault();
    fieldName = $(this).attr('field');
    var currentVal = parseInt($('input[id='+fieldName+']').val());
    if (!isNaN(currentVal) && currentVal > 0) {
      $('input[id='+fieldName+']').val(currentVal - 1);
    } else {
      $('input[id='+fieldName+']').val(0);
    }
  });



  

  
  if($("#instafeed").length){
    var instagramParser = new Nanogram();
    instagramParser.getMediaByUsername('creativesoul').then(function (media) {
      images = media.profile.edge_owner_to_timeline_media.edges;
      var numberOfImages = images.length;
      if (numberOfImages > 12) {
        numberOfImages = 12;
      }
      for (i = 0; i < numberOfImages; i++) {
        $("#instafeed").append('<div class="item col-lg-2 col-md-3"><a target="_blank" href="https://www.instagram.com/p/' + images[i].node.shortcode + '"><img src="' + images[i].node.thumbnail_src + '" alt="' + images[i].node.accessibility_caption + '" /></a></div>');
      }
    });
  }
  
  

});


$(window).load(function(){

  // featured collection
  var swiperThreeColumns = new Swiper('.product-swiper-three-columns', {
    loop: false,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // Når skærmbredden er ≤ 576px (typisk mobil)
      0: {
        slidesPerView: 1
      },
      577: {
        slidesPerView: 3, // Standard 3 produkter for større skærme
        spaceBetween: 30,
      }
    }
  });


  var swiperTwoRowsTwoColumns = new Swiper('.product-swiper-two-rows-two-columns', {
    slidesPerView: 2,
    slidesPerColumn: 2,
    slidesPerGroup: 2,
    spaceBetween: 30,
    loop: false,
    slideClass: 'product-item',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is >= 320px
      // 320: {
      //   slidesPerView: 2,
      //   spaceBetween: 20
      // },
      // // when window width is >= 480px
      // 480: {
      //   slidesPerView: 3,
      //   spaceBetween: 30
      // },
      // when window width is >= 1199
      300: {
        slidesPerView: 2,
        slidesPerColumn: 1,
        slidesPerGroup: 2,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 3,
        slidesPerColumn: 1,
        slidesPerGroup: 3
      },
      1200: {
        slidesPerView: 2,
        slidesPerColumn: 2,
        slidesPerGroup: 2,
      }
    }
  });

  var swiperTwoRowsFourColumns = new Swiper('.product-swiper-two-rows-four-columns', {
    slidesPerView: 4,
    slidesPerColumn: 2,
    slidesPerGroup: 4,
    spaceBetween: 30,
    loop: true,
    slideClass: 'product-item',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is >= 320px
      // 320: {
      //   slidesPerView: 2,
      //   spaceBetween: 20
      // },
      // // when window width is >= 480px
      // 480: {
      //   slidesPerView: 3,
      //   spaceBetween: 30
      // },
      // when window width is >= 1199
      300: {
        slidesPerView: 2,
        slidesPerColumn: 1,
        slidesPerGroup: 2,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 3,
        slidesPerColumn: 2,
        slidesPerGroup: 3
      },
      992: {
        slidesPerView: 3,
        slidesPerColumn: 2,
        slidesPerGroup: 3
      },
      1200: {
        slidesPerView: 4,
        slidesPerColumn: 2,
        slidesPerGroup: 4
      }
    }
  });


  var swiperProductsWide = new Swiper('.product-swiper-wide', {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 30,
    loop: true,
    slideClass: 'product-item',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is >= 320px
      // 320: {
      //   slidesPerView: 2,
      //   spaceBetween: 20
      // },
      // // when window width is >= 480px
      // 480: {
      //   slidesPerView: 3,
      //   spaceBetween: 30
      // },
      // when window width is >= 1199
      300: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3
      },
      992: {
        slidesPerView: 3,
        slidesPerGroup: 3
      },
      1200: {
        slidesPerView: 4,
        slidesPerGroup: 4
      }
    }
  });

  var swiperPromoted = new Swiper('.promoted-swiper', {
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 9000,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
  });
  

  // // init Isotope
  // var $grid = $('.product-grid-iso').isotope({

  //   itemSelector: '.product-item',
  //   percentPosition: true,
  //   sortAscending: false,
  //   masonry: {
  //     // use element for option
  //     columnWidth: '.grid-sizer'
  //   }
  //   // options
  // });

  
  
  // filter items on button click

  function concatValues( obj ) {
    var value = '';
    for ( var prop in obj ) {
      value += obj[ prop ];
    }
    return value;
  }

  
  
  
  $('.filter-button-group, .choose-format, .category-wrapper .dropdown, .isotope-reset').on( 'click', 'button', function() {
    
//    var $buttonGroup = $(this).parents('.filters');
//    var filterGroup = $buttonGroup.attr('data-filter-group');
//    // set filter for group
//    filters[ filterGroup ] = $(this).attr('data-filter');
//    // combine filters
//    var filterValue = concatValues( filters );
//    $grid.isotope({ filter: filterValue });
//
//    console.log(filterValue);
//    $(".product-item").removeClass("aos-init aos-animate");
//    $(".product-item").removeAttr( "data-aos" );


//    $(".pagination a, dropdown a").each(function(){
//      var newHref = "filter=" + filterValue;
//      var number = $(this).text();
//      var re = new RegExp("&filter=[^&]*&?");
//      var oldUrl = $(this).attr("href").replace(re, '');
//      $(this).attr("href",oldUrl + "&" + newHref);
//    })
//  });
//
//  $(".pagination a, dropdown a").each(function(){
//      var newHref = "filter=" + filterValue;
//      var number = $(this).text();
//      var re = new RegExp("&filter=[^&]*&?");
//      var oldUrl = $(this).attr("href").replace(re, '');
//      $(this).attr("href",oldUrl + "&" + newHref);
  })

  $(".pagination-btn").click(function(e){
    e.preventDefault(); 
    if($(this).hasClass("prev")){
      var url = $(".pagination li.current").prev("li").find("a").attr("href");
      if(url != undefined){
        window.location.href = $(".pagination li.current").prev("li").find("a").attr("href");
      }
    }
    if ($(this).hasClass("next")) {
      var url = $(".pagination li.current").next("li").find("a").attr("href");
      if(url != undefined){
        window.location.href = $(".pagination li.current").next("li").find("a").attr("href");
      }
    }
  });



  //sorts
  $('#sorts-new').on( 'click', function() {
    $grid.isotope({ sortBy : 'number' });
    $(".product-item").removeClass("aos-init aos-animate");
    $(".product-item").removeAttr( "data-aos" );
  });
  $('#sorts-ori').on( 'click', function() {
    $grid.isotope({ sortBy : 'original-order' });
    $(".product-item").removeClass("aos-init aos-animate");
    $(".product-item").removeAttr( "data-aos" );
  });

  //sort dropdown

  $(".dropdown").each(function(){
    $(this).attr("data-original-label", $(this).find(".dropdown-btn").text());
  });

  $(document).on("click", ".dropdown-btn", function(e){
    e.preventDefault();
    $(this).parent(".dropdown").toggleClass("open");
  });

  $(document).on("click", ".dropdown-list a", function (e) {
    $(this).closest(".dropdown").removeClass("open").find(".dropdown-btn").text($(this).text());
  });


  $(".filter-button-group button").on('click', function(){

    $(".filter-button-group button").removeClass("selected"); 

    if($(this).hasClass("selected")){
      $(this).removeClass("selected");
    }else{
      $(this).addClass("selected");
    }
  })

  $(".choose-format button").on('click', function(){
    var str = $(this).text();
    
    $(".choose-format button").removeClass("selected"); 
    
    if($(this).hasClass("selected")){
    	$(this).removeClass("selected");
    }else{
    	$(this).addClass("selected");
    }
    if(str.includes("Vertical")){
      $(".product-item img").each(function(){
        if($(this).attr("alt").includes("vertical")){
          $(this).parent().find("img").hide(); 
          $(this).css("display", "block");
        }
      })
    }else if(str.includes("Horizontal")){
      $(".product-item img").each(function(){
        if($(this).attr("alt").includes("horizontal")){
          $(this).parent().find("img").hide(); 
          $(this).css("display", "block");
        }
      })
    }else{
      $(".product-item img").each(function(){
        if($(this).attr("alt").includes("square")){
          $(this).parent().find("img").hide(); 
          $(this).css("display", "block");
        }
      })
    }
  })

  
  $(".isotope-reset").on('click', function(){
    $(".choose-format button").removeClass("selected"); 
    $(".filter-button-group button").removeClass("selected"); 
    $grid.isotope({
      filter: '*'
    });

  });
  
  $("#header .header-content .navigation .header-social").clone().appendTo(".mobile-social-icons");
  $("#header .header-content .top .currency-selector").clone().appendTo(".mobile-currency-selector");
  
  $('.nav-men').find('li').each(function(){
    if ($(this).children('a').attr('href') == window.location.pathname) {
      $(this).children('a').css("color", "#000")
      $(this).children('a').addClass('gr-active')
    }
  });
  $('.collection-widget').find('li').each(function(){
    if ($(this).children('a').attr('href') == window.location.pathname) {
      $(this).children('a').css("color", "#000")
      $(this).children('a').addClass('gr-active')
    }
  });

  // AOS start

  AOS.init({
    duration: 800,
    once: true,

  });

  $("html").addClass("loaded");
  

  // mobileMenuMaxHeigth();

  // $(window).on("scroll", function () {
  //   mobileMenuMaxHeigth();
  // });
  // $(window).on("resize", function () {
  //   mobileMenuMaxHeigth();
  // });

})
// $("#mobile-menu-trigger").click(function() {
//   if ($(".menu-widget.newest-art.large-3 h4").css("float") == "none" ) {
//     $(".menu-widget.newest-art.large-3 img").height($("#first-col .widget-list").height()+'px');
//     //console.log($(".header-container nav#menu .menu-widgets .menu-widget .widget-list").height())
//   }
// })

// function mobileMenuMaxHeigth(){
//   if ($(window).width() < 768) {
//     var maxHeight = window.innerHeight - $("#header").outerHeight();
//     $("#header .header-content").css("max-height", maxHeight + "px");
//   }
// }

// Cookies
function createCookie(name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "; expires=" + date.toGMTString();
  }
  else var expires = "";
  document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function cookieExists(name) {
  if (document.cookie.indexOf(name) >= 0) {
    return true;
  } else {
    return false;
  }
}

equalheight = function(container){
  var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = new Array(),
      $el,
      topPosition = 0;
  $(container).each(function() {

    $el = $(this);
    $($el).height('auto')
    topPostion = $el.position().top;

    if (currentRowStart != topPostion) {
      for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPostion;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
    }
    for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
}

function cartCountItems(){
  jQuery.getJSON('/cart.js', function (cart) {
    $('.header-main .number-wrapper .cart-count-num').html(cart.item_count);
    if(cart.item_count > 0){
      $('.header-main .number-wrapper').addClass('active');
    }else{
      $('.header-main .number-wrapper').removeClass('active');
    }
  });
}


const targetElement = $0;

if (!targetElement) {
  const data = { error: 'Element not found.' };
} else {
  const newUrl = 'https://www.example.com';
  const replacementFunction = (event) => {
    event.preventDefault(); // Prevent default action.
    event.stopPropagation(); // Stop propagation to parent elements.
    window.location.href = newUrl;
  };
  targetElement.addEventListener('click', replacementFunction, true); //Use capture phase to execute first

  const data = {
    message: `An event listener has been attached to the element. Clicking on it will now redirect to: ${newUrl}.`
  };
}

